import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';

import { createDialogServiceBase } from 'tiime-material';

import { MissionAcceptance } from '@models/mission-acceptance/mission-acceptance';

import { CreateOrUpdateMissionAcceptanceDialogData } from './create-or-update-mission-acceptance-dialog-data';
import { CreateOrUpdateMissionAcceptanceDialogComponent } from './create-or-update-mission-acceptance-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CreateOrUpdateMissionAcceptanceDialogService extends createDialogServiceBase<
  MissionAcceptance,
  CreateOrUpdateMissionAcceptanceDialogData
>(CreateOrUpdateMissionAcceptanceDialogComponent) {
  override open(config: MatDialogConfig<CreateOrUpdateMissionAcceptanceDialogData>): this {
    if (this.dialogRef) {
      this.dialogRef.close(null);
    }
    this.dialogRef = this.dialog.open(CreateOrUpdateMissionAcceptanceDialogComponent, {
      panelClass: ['tiime-dialog-panel', 'mission-acceptance-dialog-panel'],
      height: 'calc(100% - 100px)',
      width: 'calc(100% - 100px)',
      ...config
    });
    this.dialogRef.updatePosition({
      left: '50px',
      top: '50px'
    });
    return this;
  }
}
